import React, { useEffect } from 'react';
import { useIntl } from 'react-intl';
import {
  FormLabel,
  FormControl,
  RadioGroup,
  Radio,
  FormControlLabel,
  FormHelperText,
} from '@mui/material';
import { useFormContext } from 'react-hook-form';
import { useFieldRequired } from './fieldRequiredContext';

const FormRadioStack = function FormRadioStack({
  name,
  label = '',
  defaultValue = '',
  required = false,
  options = [],
  row = false,
  error = null,
}) {
  const intl = useIntl();
  const { register, getValues, clearErrors, watch, setValue } =
    useFormContext();
  const { message = null } = error || {};
  const effectiveRequired = useFieldRequired(required);
  const watcher = watch(name);
  const nameTranslation = intl.messages[name?.toUpperCase()] ?? null;

  useEffect(() => {
    if (defaultValue && !getValues(name)) {
      setValue(name, defaultValue);
    }
  }, []);

  useEffect(() => {
    clearErrors(name);
  }, [watcher]);

  return (
    <FormControl required={effectiveRequired} error={error} fullWidth>
      <FormLabel
        id={`label-${name}`}
        sx={{
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: 'noWrap',
        }}
      >
        {label || nameTranslation}
      </FormLabel>
      <RadioGroup
        row={row}
        aria-labelledby={`label-${name}`}
        defaultValue={defaultValue || ''}
      >
        {options.map((item) => (
          <FormControlLabel
            id={`${name}-radioBtn`}
            {...register(name, {
              required: {
                value: effectiveRequired,
                message: intl.messages.MANDATORY_FIELD,
              },
            })}
            name={name}
            key={typeof item === 'string' ? item : item?.value}
            value={typeof item === 'string' ? item : item?.value}
            label={
              typeof item === 'string'
                ? intl.messages[item] || item
                : intl.messages[item?.label] || item?.label
            }
            control={<Radio />}
          />
        ))}
      </RadioGroup>
      {message && (
        <FormHelperText
          sx={{
            whiteSpace: 'noWrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
          }}
        >
          {message || ' '}
        </FormHelperText>
      )}
    </FormControl>
  );
};

export default FormRadioStack;
